import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import TextArea from 'antd/lib/input/TextArea';
import { CancelTokenSource } from 'axios';
import { get } from 'lodash';
import moment from 'moment';
import AttachmentModal from 'components/community/parts/modal/CompleteModal';
import apiClient, { makeQueryString, WrappingApiClient } from 'libs/api/apiClient';
import { handleFieldError, moveToFirstError } from 'libs/api/errorHandle';
import { makeLastNYearsList } from 'libs/utils';
import { CWindowWidth } from 'constants/base.const';
import { ENotificationType } from 'enums/base.enum';
import { Button, Form, message, Checkbox } from 'antd';
import styled from 'styled-components';
import { PrimaryColor, SecondaryColor, device } from 'GlobalStyles';
import { FormWrapper } from 'GlobalStyles';
import PassQualiticationWrite from '../parts/PassQualificationWrite';
import SharingInterviewForm from '../parts/SharingInterviewForm';
import CompanyAndEmploymentType from './components/CompanyAndEmploymentType';
import InterviewDate from './components/InterviewDate';

const FinalAcceptanceWrite = () => {
  const [form] = Form.useForm();
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [showOnlineReview, setShowOnlineReview] = useState(false);
  const [showPTInterview, setPTInterview] = useState(false);
  const [showSharingInterview, setShowSharingInterview] = useState({
    first: true,
    second: true,
    third: true,
    fourth: false,
    fifth: false,
    sixth: false,
    seventh: false,
  });
  const [isOnCompleteModal, setIsOnCompleteModal] = useState(false);

  const getSharingInterviews = (count: string) => {
    if (count === 'first') {
      let isOn = showSharingInterview.first;
      setShowSharingInterview((prev) => ({ ...prev, first: !isOn }));
    }
    if (count === 'second') {
      let isOn = showSharingInterview.second;
      setShowSharingInterview((prev) => ({ ...prev, second: !isOn }));
    }
    if (count === 'third') {
      let isOn = showSharingInterview.third;
      setShowSharingInterview((prev) => ({ ...prev, third: !isOn }));
    }
    if (count === 'fourth') {
      let isOn = showSharingInterview.fourth;
      setShowSharingInterview((prev) => ({ ...prev, fourth: !isOn }));
    }
    if (count === 'fifth') {
      let isOn = showSharingInterview.fifth;
      setShowSharingInterview((prev) => ({ ...prev, fifth: !isOn }));
    }
    if (count === 'sixth') {
      let isOn = showSharingInterview.sixth;
      setShowSharingInterview((prev) => ({ ...prev, sixth: !isOn }));
    }
    if (count === 'seventh') {
      let isOn = showSharingInterview.seventh;
      setShowSharingInterview((prev) => ({ ...prev, seventh: !isOn }));
    }
  };

  const createBoard = (params: any, cancel?: CancelTokenSource) => {
    return apiClient.post(`/community/final_review`, params, {
      cancelToken: cancel?.token,
    });
  };

  const onClickSubmit = () => {
    form
      .validateFields()
      .then((value) => {
        handleUpdate();
      })
      .catch((errorInfo) => {
        message.error('필수 사항을 입력해주세요.');
        moveToFirstError(form, errorInfo.errorFields);
      });

    async function handleUpdate() {
      try {
        setSubmitButtonDisabled(true);

        const document = {
          interview_type: 'cv',
          body_for_pass_interview: form.getFieldValue('document'),
        };

        let onlineTest = {};

        if (form.getFieldValue('onlineTest')) {
          onlineTest = {
            interview_type: 'online',
            body_for_pass_interview: form.getFieldValue('onlineTest'),
          };
        }

        let ptInterview = {};

        if (form.getFieldValue('ptInterview')) {
          ptInterview = {
            interview_type: 'pt',
            body_for_pass_interview: form.getFieldValue('ptInterview'),
          };
        }

        let firstInterview = {};

        if (form.getFieldValue('interview_review')[0].interview_type) {
          firstInterview = {
            interview_type: '1st_interview',
            problem_solving: form.getFieldValue('interview_review')[0].problem_solving,
            interview_progress: form.getFieldValue('interview_review')[0].interview_progress,
            interview_atmosphere: form.getFieldValue('interview_review')[0].interview_atmosphere,
            interview_level: form.getFieldValue('interview_review')[0].interview_level,
            fit_importance: form.getFieldValue('interview_review')[0].fit_importance,
            case_importance: form.getFieldValue('interview_review')[0].case_importance,
            questions: form.getFieldValue('interview_review')[0].interview_question,
          };
        } else {
          firstInterview = {};
        }

        let secondInterview = {};

        if (form.getFieldValue('interview_review')[1].interview_type) {
          secondInterview = {
            interview_type: '2nd_interview',
            problem_solving: form.getFieldValue('interview_review')[1].problem_solving,
            interview_progress: form.getFieldValue('interview_review')[1].interview_progress,
            interview_atmosphere: form.getFieldValue('interview_review')[1].interview_atmosphere,
            interview_level: form.getFieldValue('interview_review')[1].interview_level,
            fit_importance: form.getFieldValue('interview_review')[1].fit_importance,
            case_importance: form.getFieldValue('interview_review')[1].case_importance,
            questions: form.getFieldValue('interview_review')[1].interview_question,
          };
        } else {
          secondInterview = {};
        }

        let thirdInterview = {};

        if (form.getFieldValue('interview_review')[2].interview_type) {
          thirdInterview = {
            interview_type: '3rd_interview',
            problem_solving: form.getFieldValue('interview_review')[2].problem_solving,
            interview_progress: form.getFieldValue('interview_review')[2].interview_progress,
            interview_atmosphere: form.getFieldValue('interview_review')[2].interview_atmosphere,
            interview_level: form.getFieldValue('interview_review')[2].interview_level,
            fit_importance: form.getFieldValue('interview_review')[2].fit_importance,
            case_importance: form.getFieldValue('interview_review')[2].case_importance,
            questions: form.getFieldValue('interview_review')[2].interview_question,
          };
        } else {
          thirdInterview = {};
        }

        let fourthInterview = {};

        if (form.getFieldValue('interview_review')[3].interview_type) {
          fourthInterview = {
            interview_type: '4th_interview',
            problem_solving: form.getFieldValue('interview_review')[3].problem_solving,
            interview_progress: form.getFieldValue('interview_review')[3].interview_progress,
            interview_atmosphere: form.getFieldValue('interview_review')[3].interview_atmosphere,
            interview_level: form.getFieldValue('interview_review')[3].interview_level,
            fit_importance: form.getFieldValue('interview_review')[3].fit_importance,
            case_importance: form.getFieldValue('interview_review')[3].case_importance,
            questions: form.getFieldValue('interview_review')[3].interview_question,
          };
        } else {
          fourthInterview = {};
        }

        let fifthInterview = {};

        if (form.getFieldValue('interview_review')[4].interview_type) {
          fifthInterview = {
            interview_type: '5th_interview',
            problem_solving: form.getFieldValue('interview_review')[4].problem_solving,
            interview_progress: form.getFieldValue('interview_review')[4].interview_progress,
            interview_atmosphere: form.getFieldValue('interview_review')[4].interview_atmosphere,
            interview_level: form.getFieldValue('interview_review')[4].interview_level,
            fit_importance: form.getFieldValue('interview_review')[4].fit_importance,
            case_importance: form.getFieldValue('interview_review')[4].case_importance,
            questions: form.getFieldValue('interview_review')[4].interview_question,
          };
        } else {
          fifthInterview = {};
        }

        let sixthInterview = {};

        if (form.getFieldValue('interview_review')[5].interview_type) {
          sixthInterview = {
            interview_type: '6th_interview',
            problem_solving: form.getFieldValue('interview_review')[5].problem_solving,
            interview_progress: form.getFieldValue('interview_review')[5].interview_progress,
            interview_atmosphere: form.getFieldValue('interview_review')[5].interview_atmosphere,
            interview_level: form.getFieldValue('interview_review')[5].interview_level,
            fit_importance: form.getFieldValue('interview_review')[5].fit_importance,
            case_importance: form.getFieldValue('interview_review')[5].case_importance,
            questions: form.getFieldValue('interview_review')[5].interview_question,
          };
        } else {
          sixthInterview = {};
        }

        let seventhInterview = {};

        if (form.getFieldValue('interview_review')[6].interview_type) {
          seventhInterview = {
            interview_type: '7th_interview',
            problem_solving: form.getFieldValue('interview_review')[6].problem_solving,
            interview_progress: form.getFieldValue('interview_review')[6].interview_progress,
            interview_atmosphere: form.getFieldValue('interview_review')[6].interview_atmosphere,
            interview_level: form.getFieldValue('interview_review')[6].interview_level,
            fit_importance: form.getFieldValue('interview_review')[6].fit_importance,
            case_importance: form.getFieldValue('interview_review')[6].case_importance,
            questions: form.getFieldValue('interview_review')[6].interview_question,
          };
        } else {
          seventhInterview = {};
        }

        let final_pass_data: any = [document];

        if (showOnlineReview) {
          final_pass_data.push(onlineTest);
        }
        if (showPTInterview) {
          final_pass_data.push(ptInterview);
        }
        if (showSharingInterview.first) {
          final_pass_data.push(firstInterview);
        }
        if (showSharingInterview.second) {
          final_pass_data.push(secondInterview);
        }
        if (showSharingInterview.third) {
          final_pass_data.push(thirdInterview);
        }
        if (showSharingInterview.fourth) {
          final_pass_data.push(fourthInterview);
        }
        if (showSharingInterview.fifth) {
          final_pass_data.push(fifthInterview);
        }
        if (showSharingInterview.sixth) {
          final_pass_data.push(sixthInterview);
        }
        if (showSharingInterview.seventh) {
          final_pass_data.push(seventhInterview);
        }

        let changeExperienced = () => {
          let interns = form
            .getFieldValue('experienced_interns')
            .map(({ is_intern, experienced_intern_id, experienced_intern_name }: any) => ({
              is_intern,
              company_name: experienced_intern_name,
              id: experienced_intern_id ? experienced_intern_id : null,
            }));
          return interns;
        };

        let changeExperienced2 = () => {
          let interns = form
            .getFieldValue('experienced_worker')
            .map(({ is_intern, experienced_worker_id, experienced_worker_name }: any) => ({
              is_intern,
              company_name: experienced_worker_name,
              id: experienced_worker_id ? experienced_worker_id : null,
            }));
          return interns;
        };

        let allExperienced: any = [];

        if (form.getFieldValue('experienced_interns') && form.getFieldValue('experienced_worker')) {
          allExperienced = [...changeExperienced(), ...changeExperienced2()];
        }
        if (!form.getFieldValue('experienced_interns') && form.getFieldValue('experienced_worker')) {
          allExperienced = [...changeExperienced2()];
        }
        if (form.getFieldValue('experienced_interns') && !form.getFieldValue('experienced_worker')) {
          allExperienced = [...changeExperienced()];
        }
        if (!form.getFieldValue('experienced_interns') && !form.getFieldValue('experienced_worker')) {
          allExperienced = [];
        }

        const data = {
          education: {
            id: form.getFieldValue('university_id') ? form.getFieldValue('university_id') : null,
            university_name: form.getFieldValue('university_name')
              ? form.getFieldValue('university_name')
              : null,
          },
          major: {
            id: form.getFieldValue('major_id') ? form.getFieldValue('major_id') : null,
            major_name: form.getFieldValue('major_name') ? form.getFieldValue('major_name') : null,
          },
          gpa: form.getFieldValue('my_score'),
          gpa_type: form.getFieldValue('total_score'),
          resume_file_id: form.getFieldValue('resume_file_id'),
          pass_tip: form.getFieldValue('first_interview_question'),
          case_study: form.getFieldValue('second_interview_question'),
          experience_for_career: form.getFieldValue('third_interview_question'),
          final_pass_interview_type: final_pass_data,
          final_pass_interview_work_experience: allExperienced,
          interview_information: {
            company_id: form.getFieldValue('company_id') ? form.getFieldValue('company_id') : null,
            company_name: form.getFieldValue('company_name'),
            employment_type: form.getFieldValue('employment_type'),
            interview_date: moment(
              `${form.getFieldValue('interview_date_year')}-${form.getFieldValue(
                'interview_date_month',
              )}-10 12:00`,
            ).format('YYYY-MM-DD HH:mm'),
          },
        };

        await createBoard(data);

        setIsOnCompleteModal(true);
      } catch (e) {
        message.error('필수 사항을 입력해주세요.');
        handleFieldError(e, form);
        throw e;
      } finally {
        setSubmitButtonDisabled(false);
      }
    }
  };

  const onClickGetMyCareer = async () => {
    const { success, data } = await WrappingApiClient(apiClient.get(`/community/career_experience`));

    if (get(data, 'resume_file')) {
      form.setFieldsValue({
        resume_files: [
          {
            uid: get(data, 'resume_file.id'),
            status: 'done',
            name: get(data, 'resume_file.file_name'),
            absolute_url: get(data, 'resume_file.absolute_url'),
          },
        ],
        resume_file_id: null,
      });
    }

    let changeExperiencedIntern: any = [];
    if (get(data, 'intern_career').length > 0) {
      data.intern_career.forEach((el: any) => {
        changeExperiencedIntern.push({
          experienced_intern_name: el.company_name,
          experienced_intern_id: el.id ? el.id : null,
          is_intern: true,
        });
      });
    }

    let changeExperiencedWorker: any = [];
    if (get(data, 'experienced_career').length > 0) {
      data.intern_career.forEach((el: any) => {
        changeExperiencedWorker.push({
          experienced_worker_name: el.company_name,
          experienced_worker_id: el.id ? el.id : null,
          is_intern: false,
        });
      });
    }

    if (success) {
      form.setFieldsValue({
        university_id: data.university?.id,
        university_name: data.university?.university_name,
        major_id: data.major?.id,
        major_name: data.major?.major_name,
        experienced_interns: changeExperiencedIntern,
        experienced_worker: changeExperiencedWorker,
        resume_files: data.resume_file
          ? [
              {
                uid: get(data, 'resume_file.id'),
                status: 'done',
                name: get(data, 'resume_file.file_name'),
                absolute_url: get(data, 'resume_file.absolute_url'),
              },
            ]
          : null,
      });
    } else {
      message.error('관리자에게 문의하세요.');
    }
  };

  return (
    <StyledContainer>
      <StyledHeader>
        <h1 className='title'>최종합격 후기 등록하기</h1>
        <div className='expandCommant'>*등록한 내용은 익명으로 사용됩니다.</div>
      </StyledHeader>
      <FormWrapper>
        <Form
          form={form}
          layout='vertical'
          className='form-normal'
          requiredMark={false}
          scrollToFirstError={true}
        >
          <StyledInputSections>
            <StyledInputSectionTitle>{'합격후기\n등록하기'}</StyledInputSectionTitle>
            <StyledInputSection>
              <CompanyAndEmploymentType form={form} />
              <InterviewDate lastNYearsList={makeLastNYearsList(4)} />
            </StyledInputSection>
          </StyledInputSections>

          <StyledInputSections>
            <StyledInputSectionTitle>
              <div>{'합격스펙\n등록하기'}</div>
              <Button className='secondary' onClick={() => onClickGetMyCareer()}>
                계정 정보 불러오기
              </Button>
            </StyledInputSectionTitle>
            <StyledInputSection>
              <PassQualiticationWrite form={form} />
            </StyledInputSection>
          </StyledInputSections>

          <StyledInputSections>
            <StyledInputSectionTitle>
              <div>{'인터뷰\n공유하기'}</div>
              <p className='explanation'>
                {'각 단계별 문제 풀이\n접근법 및 응시 후기를\n상세하게 적어주세요'}
              </p>
            </StyledInputSectionTitle>
            <StyledInputSection>
              <div className='checkBoxes'>
                <Checkbox className='green-border-checkbox' defaultChecked>
                  서류
                </Checkbox>
                <Checkbox
                  className='green-border-checkbox'
                  onClick={() => {
                    setShowOnlineReview((prev) => !prev);
                    showOnlineReview && form.setFieldsValue({ onlineTest: '' });
                  }}
                >
                  온라인 테스트
                </Checkbox>
                <Checkbox
                  className='green-border-checkbox'
                  onClick={() => {
                    setPTInterview((prev) => !prev);
                    showPTInterview && form.setFieldsValue({ ptInterview: '' });
                  }}
                >
                  PT
                </Checkbox>
                <Checkbox className='green-border-checkbox' onClick={() => getSharingInterviews('first')}>
                  1차 인터뷰
                </Checkbox>
                <Checkbox className='green-border-checkbox' onClick={() => getSharingInterviews('second')}>
                  2차 인터뷰
                </Checkbox>
                <Checkbox className='green-border-checkbox' onClick={() => getSharingInterviews('third')}>
                  3차 인터뷰
                </Checkbox>
                <Checkbox className='green-border-checkbox' onClick={() => getSharingInterviews('fourth')}>
                  4차 인터뷰
                </Checkbox>
                <Checkbox className='green-border-checkbox' onClick={() => getSharingInterviews('fifth')}>
                  5차 인터뷰
                </Checkbox>
                <Checkbox className='green-border-checkbox' onClick={() => getSharingInterviews('sixth')}>
                  6차 인터뷰
                </Checkbox>
                <Checkbox className='green-border-checkbox' onClick={() => getSharingInterviews('seventh')}>
                  7차 인터뷰
                </Checkbox>
              </div>
              <div>
                <div className='label' style={{ marginBottom: '7px' }}>
                  서류 tip 및 후기를 상세하게 적어주세요
                </div>

                <Form.Item
                  name='document'
                  className='form-item community-selector'
                  rules={[{ required: true }, { min: 150, message: '최소 150자 이상이어야 합니다' }]}
                >
                  <TextArea
                    autoSize={{ minRows: 4 }}
                    size='large'
                    placeholder='기본 요건만 갖춘다면 크게 중요하지 않은 것 같습니다. 기본 요건이라하면 타겟 대학, 적당한 학점, 열심히 살아왔으며 컨설팅에 관심이 있음을 보여주는 각종 이력을 말합니다. 물론 맥킨지는 서류를 정성들여 쓰시는게 중요할 것 같습니다. 저는 맥킨지는 서류를 탈락해서 이만 줄일게요…'
                  />
                </Form.Item>
              </div>
              <div style={{ display: showOnlineReview ? 'block' : 'none' }}>
                <div style={{ marginBottom: '7px' }}>
                  온라인 테스트 후기 및 공부방법을 상세하게 적어주세요
                </div>
                <Form.Item
                  name='onlineTest'
                  className='form-item community-selector'
                  rules={[{ min: 150, message: '최소 150자 이상이어야 합니다' }]}
                >
                  <TextArea
                    autoSize={{ minRows: 4 }}
                    size='large'
                    placeholder='짧은 시간안에 dirty decision을 내리는 게 가장 중요한 것 같습니다. 저는 머리가 엄청 빠르게 돌아는 천재과가 아니라서, 모든 문제를 다 맞추지는 못하겠고 시간을 들여도 못풀 것 같은 문제는 빨리 제꼈습니다. 그리고 시간을 들이면 확실히 맞출 것 같은 문제에 시간을 많이 들여서 선택적으로 풀었습니다.'
                  />
                </Form.Item>
              </div>
              <div style={{ display: showPTInterview ? 'block' : 'none' }}>
                <div style={{ marginBottom: '7px' }}>PT면접 준비방법을 상세하게 적어주세요</div>
                <Form.Item
                  name='ptInterview'
                  className='form-item community-selector'
                  rules={[{ min: 150, message: '최소 150자 이상이어야 합니다' }]}
                >
                  <TextArea
                    autoSize={{ minRows: 4 }}
                    size='large'
                    placeholder='텍스트 박스 (4줄) 최소 50자'
                  />
                </Form.Item>
              </div>

              <SharingInterviewForm
                isFinal
                isConsultingFirm={true}
                form={form}
                checkedRound={[
                  showSharingInterview.first ? 1 : 0,
                  showSharingInterview.second ? 2 : 0,
                  showSharingInterview.third ? 3 : 0,
                  showSharingInterview.fourth ? 4 : 0,
                  showSharingInterview.fifth ? 5 : 0,
                  showSharingInterview.sixth ? 6 : 0,
                  showSharingInterview.seventh ? 7 : 0,
                ]}
                boardName={'finalAcceptance'}
                totalRound={7}
              />
            </StyledInputSection>
          </StyledInputSections>
        </Form>
      </FormWrapper>

      <div className='registerBtn'>
        <Button type='primary' loading={submitButtonDisabled} onClick={() => onClickSubmit()}>
          등록하기
        </Button>
      </div>
      <AttachmentModal
        visible={isOnCompleteModal}
        setVisible={setIsOnCompleteModal}
        ListPath={'/community/final_acceptance'}
      >
        <StyledAttachmentModalContainer>
          <p className='boldText'>
            소중한 면접 경험 공유해주셔서 감사합니다
            <br />
            경품은 Career Step 내부 검수가 끝난 후 이메일을 통해 안내드립니다
          </p>
          <p className='lighterText'>
            *Career Step 내부 검수 후 내용이 적절하지 않을 경우 경품 대상 제외 및 원문 삭제 될 수 있습니다
          </p>
        </StyledAttachmentModalContainer>
      </AttachmentModal>
    </StyledContainer>
  );
};

export default FinalAcceptanceWrite;

const StyledContainer = styled.main`
  max-width: ${CWindowWidth - 500}px;
  margin: 140px auto 0 auto;
  padding: 0 50px;
  word-break: keep-all;

  @media screen and ${device.sm} {
    padding: 0 20px;
  }

  .registerBtn {
    display: flex;
    justify-content: flex-end;
    margin: 50px 0 150px 0;

    .ant-btn {
      width: 50%;
      padding: 20px !important;
      line-height: 1px;

      @media screen and ${device.sm} {
        width: 100%;
      }
    }
  }
`;

const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  padding-bottom: 5px;
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: 10px;

  @media screen and ${device.lg} {
    flex-direction: column;
    align-items: flex-start;
  }

  .title {
    margin: 0 10px 0 0;
    font-size: 24px;
    font-weight: 900;
    color: ${PrimaryColor};
  }

  .expandComment {
    color: #747474;
  }
`;

const StyledInputSections = styled.section`
  display: flex;
  justify-content: space-between;
  margin-top: 50px;

  @media screen and ${device.sm} {
    flex-direction: column;
  }
`;

const StyledInputSectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 900;
  color: ${SecondaryColor};
  white-space: pre-line;

  .ant-btn {
    margin-top: 15px;
    padding: 12px 14px !important;
    line-height: 8px;

    @media screen and ${device.sm} {
      width: 100%;
    }
  }

  .explanation {
    margin-top: 15px;
    font-size: 14px;
    font-weight: 100;
  }
`;

const StyledInputSection = styled.div`
  width: 75%;

  @media screen and ${device.sm} {
    width: 100%;
  }

  .checkBoxes {
    margin-bottom: 30px;

    .ant-checkbox-wrapper {
      margin: 7px 0;
      width: 30%;
      font-size: 16px;
    }
  }
`;

const StyledAttachmentModalContainer = styled.div`
  p {
    margin-bottom: 10px;
  }

  .boldText {
    font-size: 18px;
  }

  .lighterText {
    color: #aeaeae;
  }
`;
